import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';


import KpiCountProps from "../../model/kpi-count-props";


export default function KpiCount(props: KpiCountProps){
    return(
        <Box display="flex" alignItems="center" paddingRight={5}>
            <Typography 
                component="h3"
                variant='h4'
                paddingRight={2}
                color="#ffffff"
                fontWeight="medium"
            >
                {props.count}
            </Typography>

            <Typography
                component="h3"
                variant='caption'
                color="#ffffff"
                fontWeight="medium"
            >
                {props.text}
            </Typography>
        </Box>
    )   
}